var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"hc-button",class:`hc-button--${_vm.variant}`,attrs:{"to":_vm.to,"type":_vm.tag === 'button' ? _vm.type : null,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("icon"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }